import Button from "@/components/Button";
interface Props {
	children: React.ReactNode;
	onClick: () => void;
}
export default function FooterBtn({ children, onClick }: Props) {
	return (
		<div className="flex-shrink-0  px-4.5 pb-6 pt-4 mast__btn__bg">
			<Button onClick={onClick} block>
				{children}
			</Button>
		</div>
	);
}
